namespace TabAurous.OMS {
    export namespace ProductInspectionService {
        export const baseUrl = 'OMS/ProductInspection';

        export declare function Create(request: Serenity.SaveRequest<ProductInspectionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductInspectionRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductQCList(request: QCRequest, onSuccess?: (response: Serenity.ListResponse<ProductInspectionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/ProductInspection/Create",
            Update = "OMS/ProductInspection/Update",
            Delete = "OMS/ProductInspection/Delete",
            Retrieve = "OMS/ProductInspection/Retrieve",
            List = "OMS/ProductInspection/List",
            GetProductQCList = "OMS/ProductInspection/GetProductQCList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetProductQCList'
        ].forEach(x => {
            (<any>ProductInspectionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
